import React from "react";
import {
  HeroSection,
  MainTitle,
  Description,
  TeamSection,
  SectionTitle,
  TeamGrid,
  MemberCard,
  MemberImage,
  MemberName,
  MemberPosition,
  MemberCareer,
  NamePositionWrapper,
  DescriptionEng,
} from "./styles";
import CompanyInfo from "../common/CompanyInfo";

const About: React.FC = () => {
  const teamMembers = [
    {
      position: "대표 / CEO",
      name: "김창욱",
      career:
        "직방파트너스 사업 본부장\n부동산다이어트 대표\n피키캐스트 매니저\n액센츄어 컨설팅 매니저\n고려대학교 경제학과",
      imagePath: "/images/team_kcw.png",
    },
    {
      position: "운영 / Operater",
      name: "양승훈",
      career: "부동산다이어트 매니저\n고려대학교 통계학과",
      imagePath: "/images/team_ysh.png",
    },
    {
      position: "개발리드 / Lead Developer",
      name: "유영진",
      career:
        "더리얼그룹 개발팀\nBrise 창업\n한국가스공사 대리\n세종대학교 공간정보공학",
      imagePath: "/images/team_yyj.png",
    },
    {
      position: "개발 / Developer",
      name: "김한결",
      career:
        "직방파트너스 영업기획팀 팀장\n부동산다이어트 매니저\n고려대학교 사학과",
      imagePath: "/images/team_khk.png",
    },
  ];

  return (
    <>
      <HeroSection>
        <MainTitle>{"더 나은 보건선생님들의\n하루하루를 위해"}</MainTitle>
        <Description>
          {`기술로 보건일지를 혁신하는 스마일보건 스타트업, 브레인다이브입니다.\n도전적인 팀원들과 현직 보건선생님의 자문과 함께 빠르게 성장하고 있는 스마일보건은\n전국 보건선생님들의 힘든 날 가장 먼저 떠올리는 이름이 되고자 합니다.`}
        </Description>
        <DescriptionEng>
          {`Braindive is a startup revolutionizing health record keeping through technology.\nWith a team of daring members and advice from current health teachers, SmileBogun is rapidly growing.\nWe aim to be the first name that comes to mind for health teachers across the nation on their toughest days.`}
        </DescriptionEng>
      </HeroSection>

      <TeamSection>
        <SectionTitle>{"Meet The\nTeam"}</SectionTitle>
        <TeamGrid>
          {teamMembers.map((member) => (
            <MemberCard key={member.name}>
              <MemberImage src={member.imagePath} alt={member.name} />
              <NamePositionWrapper>
                <MemberName>{member.name}</MemberName>
                <MemberPosition>{member.position}</MemberPosition>
              </NamePositionWrapper>
              <MemberCareer>
                {member.career.split("\n").map((line) => (
                  <p key={line}>{line}</p>
                ))}
              </MemberCareer>
            </MemberCard>
          ))}
        </TeamGrid>
      </TeamSection>

      {/* <AdvisorSection> 
        <SectionTitle>ADVISOR</SectionTitle>
        <AdvisorGrid>
          {teamMembers.slice(6).map((member, index) => (
            <MemberCard key={index}>
              <MemberImage src={member.imagePath} alt={member.name} />
              <MemberName>{member.name}</MemberName>
              <MemberPosition>{member.position}</MemberPosition>
              <MemberCareer>
                {member.career.split("\n").map((line, idx) => (
                  <p key={idx}>{line}</p>
                ))}
              </MemberCareer>
            </MemberCard>
          ))}
        </AdvisorGrid>
      </AdvisorSection> */}

      <CompanyInfo />
    </>
  );
};

export default About;
